import { BackSide, BoxGeometry, Group, LinearFilter, Mesh, ShaderMaterial, Vector3 } from 'three';
export default class EnvironmentLoader {
    constructor() {
    }
    generateEnv(panoramTexture) {
        const group = new Group();
        this.shader = new ShaderMaterial({
            uniforms: {
                map: {
                    type: 't', value: null
                },
                placement: {
                    type: 'v3', value: new Vector3
                },
                rotation: {
                    type: 'v3', value: new Vector3
                }
            },
            vertexShader: '\
                            varying vec3 worldPosition;\n\
                            varying vec2 vUv;\n\
                            void main () {\n\
                                vec4 p = vec4 (position, 1.0);\n\
                                worldPosition = (modelMatrix * p).xyz;\n\
                                gl_Position = projectionMatrix * modelViewMatrix * p;\n\
                            }',
            fragmentShader: '\
                            uniform sampler2D map;\n\
                            uniform vec3 placement;\n\
                            varying vec3 worldPosition;\n\
                            varying vec2 vUv;\n\
                            void main () {\n\
                                vec3 R = worldPosition;\n\
                                R.y -= placement.y;\n\
                                float r = length (R);\n\
                                vec2 uv = vUv;\n\
                                float theta = acos (-R.y / r);\n\
                                float phi = atan (R.x, -R.z);\n\
                                float roty =  (0.75 + phi  / 6.2831853072);\n\
                                roty = mod(roty, 1.0);\n\
                                if(roty < .0) {\n\
                                    roty = roty + 1.0;\n\
                                }\n\
                                vec4 test = texture2D(map, vec2 (\n\
                                    roty,\n\
                                    theta / 3.1415926536\n\
                                ));\n\
                                test *= vec4(1.12);\n\
                                gl_FragColor = test;\n\
                            }'
        });
        let geometry = new BoxGeometry(120, 50, 100);
        let texture = panoramTexture;
        texture.magFilter = LinearFilter;
        texture.minFilter = LinearFilter;
        this.shader.uniforms.map.value = texture;
        // window.pl = this.shader.uniforms.placement.value = new Vector3(0, 2400, 0);
        this.shader.side = BackSide;
        let sphere = new Mesh(geometry, this.shader);
        group.add(sphere);
        sphere.position.set(0, 0, 0);
        sphere.castShadow = false;
        // let floor_geom = new PlaneGeometry(150, 150, 1, 1);
        // this.floor_mesh = new Mesh(floor_geom, this.shader);
        // this.floor_mesh.rotation.x = Math.PI / 2;
        // this.floor_mesh.position.y = 20;
        // group.add(this.floor_mesh);
        // this.floor_mesh.position.y = -21; // so that the top lays at 0
        // let floor_mesh1 = new Mesh(floor_geom, Materials.getMaterial('shadowMaterial'));
        // floor_mesh1.rotation.x = -Math.PI/2;
        // group.add(floor_mesh1);
        // floor_mesh1.position.y = 10; // so that the top lays at 0
        // floor_mesh1.receiveShadow = true;
        return group;
    }
}
